module.exports = __webpack_public_path__ + "img/academy.02f23f71.svg";